import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPhone, faEnvelope, faMapMarkerAlt, faInstagram, faTiktok } from '@fortawesome/free-solid-svg-icons';
import { faInstagram as faInstagramBrand, faTiktok as faTiktokBrand } from '@fortawesome/free-brands-svg-icons';
import logo from '../../images/logo.png';
import conalotLogo from '../../images/conalot.png';
import superGanaLogo from '../../images/super-gana.png';
import baseURL from '../url';
import './SideMenu.css';

export default function SideMenu({ isOpen, onClose }) {
    const navigate = useNavigate();
    const [contactos, setContactos] = useState([]);

    useEffect(() => {
        cargarContacto();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto?.reverse()[0] || []);
            })
            .catch(error => {});
    };

    const handleLogoClick = () => {
        navigate('/');
        onClose();
    };

    return (
        <div className={`side-menu-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div className={`side-menu ${isOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>
                {/* Header del menú */}
                <div className="side-menu-header">
                    <div className="side-menu-logo" onClick={handleLogoClick}>
                        <img src={logo} alt="Logo" />
                        <div className="logo-text">
                            <h2>{contactos.nombre || 'Suerte Solidaria'}</h2>
                            <span>{contactos.direccion || 'Valencia, Carabobo'}</span>
                        </div>
                    </div>
                    <button className="close-button" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                {/* Información de contacto */}
                <div className="side-menu-content">
                    <div className="contact-section">
                        <h3>Contacto</h3>
                        <div className="contact-info">
                            <a href="tel:+584221437681" className="contact-item">
                                <FontAwesomeIcon icon={faPhone} />
                                <span>+58 422-1437681</span>
                            </a>
                            <a href="mailto:contacto.suertesolidaria@gmail.com" className="contact-item">
                                <FontAwesomeIcon icon={faEnvelope} />
                                <span>contacto.suertesolidaria@gmail.com</span>
                            </a>
                            {contactos.direccion && (
                                <a 
                                    href={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion)}`} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="contact-item"
                                >
                                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                                    <span>{contactos.direccion}</span>
                                </a>
                            )}
                        </div>
                    </div>

                    {/* Redes sociales */}
                    <div className="social-section">
                        <h3>Síguenos</h3>
                        <div className="social-links">
                            <a 
                                href="https://www.instagram.com/suertesolidaria?igsh=OHoxa29rZjdscGxz&utm_source=qr" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="social-link"
                            >
                                <FontAwesomeIcon icon={faInstagramBrand} />
                                <span>Instagram</span>
                            </a>
                            <a 
                                href="https://vt.tiktok.com/ZSCvQJ9uk/" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="social-link"
                            >
                                <FontAwesomeIcon icon={faTiktokBrand} />
                                <span>TikTok</span>
                            </a>
                        </div>
                    </div>

                    {/* Avalados por */}
                    <div className="endorsements-section">
                        <h3>Avalado por</h3>
                        <div className="endorsement-logos">
                            <div className="endorsement-logo manifiestalo">
                                <img src={logo} alt="Manifiéstalo Ya" />
                                {/* <div className="logo-text-small">Manifiéstalo Ya</div> */}
                            </div>
                            <div className="endorsement-logo super-gana">
                                <img src={superGanaLogo} alt="Super Gana" />
                            </div>
                            <div className="endorsement-logo conalot">
                                <img src={conalotLogo} alt="CONALOT" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
